<script lang="ts">
  import { onMount } from "svelte";
  import DossierCategoryDropdown from "../../components/Business/DossierCategoryDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import GlobalErrors from "../../components/GlobalErrors.svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import Table from "../../components/Table/Table.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IDropdownItem } from "../../services/DTO/dropdown-item";
  import { dossierTypeDtoFields } from "../../utils/TableFields/dossier-type-dto.fields";
  import {
    editing,
    init,
    loadDossierTypes,
    loading,
    onCreate,
    onDelete,
    onEdit,
    onPageChange,
    pagination,
    record,
    records,
    save,
    selectedDossierCategory,
  } from "./settings-dossier-types.store";

  $: canSubmit = $record != null && !!$record.description;

  $: isNew = $record != null && $record.oid === 0;

  async function onSubmit() {
    await save();
    editing.set(false);
    record.set(null);
  }

  function onCancel() {
    editing.set(false);
    record.set(null);
  }

  async function onDossierCategorySelect(event: CustomEvent) {
    if (event != null && event.detail != null) {
      let item: IDropdownItem = event.detail;
      selectedDossierCategory.set(item.oid);
    } else {
      selectedDossierCategory.set(0);
    }
    loadDossierTypes();
  }

  onMount(init);
</script>

{#if $editing === false}
  <SearchHeader
    entitySingular="tipo pratica"
    entityPlural="tipi pratica"
    searchPlaceholder="cerca per descrizione"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    searchFieldVisible={false}
  >
    <div class="level-item" slot="search">
      <div class="field">
        <p class="control" style="min-width:300px">
          <DossierCategoryDropdown
            name=""
            filterVisible={true}
            clearVisible={true}
            placeholder="categoria pratica"
            on:select={onDossierCategorySelect}
            on:clear={onDossierCategorySelect}
            value={$selectedDossierCategory}
          />
        </p>
      </div>
    </div>
  </SearchHeader>

  <GlobalErrors errors={[]} />

  <div style="padding-bottom: 2rem;">
    <Table
      loading={$loading}
      fields={dossierTypeDtoFields}
      records={$records}
      pagination={$pagination}
      createEnabled={true}
      editEnabled={true}
      deleteEnabled={true}
      on:create={(_) => onCreate()}
      on:edit={(e) => onEdit(e.detail)}
      on:delete={(e) => onDelete(e.detail)}
      on:pageChange={(e) => onPageChange(e.detail)}
    />
  </div>
{:else if $record != null}
  <FormLayout on:submit={onSubmit} on:cancel={onCancel} {canSubmit} {isNew}>
    <FormField usageHelp="codice numerico">
      <NumberInput
        name="Codice"
        placeholder="codice"
        required={true}
        bind:value={$record.numCode}
      />
    </FormField>

    <FormField usageHelp="descrizione visibile (200 caratteri)">
      <Input
        name="Descrizione"
        placeholder="descrizione"
        required={true}
        maxlength={200}
        bind:value={$record.description}
      />
    </FormField>

    <FormField usageHelp="categoria pratica">
      <DossierCategoryDropdown
        name="Categoria Pratica"
        required={true}
        bind:value={$record.dossierCategoryId}
      />
    </FormField>
  </FormLayout>
{/if}
